<template>

<div class="spaces" :class="{'is-picking': isPicking}">

    <app-content-head v-if="isPicking" title="Pick day & time" :inline-back="true" v-on:back="onCloseClick" subtitle="Use the visual scheduler to select a start and end time for your event.">

		<app-content-head-actions-item text="Confirm" icon="tick" :disabled="!model.space" v-on:click="onConfirmClick" />

    </app-content-head>

    <app-content-summary v-if="preferred">

		<app-content-summary-item label="Schedule Preferences" class="preferences">

				<div v-for="(time, index) in preferred" :key="index" class="preferences-time">{{ $con.schedule.days[time.day].slice(0, 3) }} {{ $con.schedule.times[time.time] }} ({{ $con.schedule.durations[time.duration] }})</div>

		</app-content-summary-item>			

	</app-content-summary>

    <app-content-box class="spaces-box" :tabs="tabs">

        <template v-for="(day, dayValue) in days" :slot="dayValue">

            <app-table class="spaces-table" :key="dayValue">

                <app-table-body>

                    <app-table-row :no-gap="true" :no-click="true" :no-hover="true" :layout="spaceLayout" key="times">

                        <app-table-cell-text />
                        <app-table-cell-times border="left" :day="dayValue" :start="room.schedule.start" :end="room.schedule.end" :times="times" />

                    </app-table-row>

                    <app-table-row :no-gap="true" :no-click="true" :layout="spaceLayout" v-for="space in spaces" :key="space.id">

                        <app-table-cell-text :text="space.name" :subtext="seatCount(space)" />
                        <app-table-cell-schedule border="left" v-on:placed="onPlaced($event, dayValue, space.id)" :current="isCurrent(dayValue, space.id)" :space="space.id" :placing="isPicking" :day="dayValue" :scheduled="scheduled" :start="room.schedule.start" :end="room.schedule.end" :times="times" />

                    </app-table-row>

                </app-table-body>

            </app-table>

        </template>

    </app-content-box>

</div>

</template>

<script>

import Vue from 'vue'

export default {

	props: ['room', 'spaces', 'preferred', 'isPicking', 'scheduled'],

	data: function() {

		return {
			spaceLayout: '64px 1fr',
            model: {
                space: '',
                day: 0,
                time: 0,
                duration: 0
            }
        }

    },

    computed: {

        tabs: function() {
        
            var tabs = []

            this.$_.each(this.days, function(text, value) {
            
                tabs.push({
                    name: value,
                    text: text
                })
            
            })

            return tabs

        },

        times: function() {
		
			return this.$con.schedule.times

		},

        days: function() {
		
			return this.$con.schedule.days

		}

    },

    created: function() {
    
        this.model.space = this.isPicking.space
        this.model.day = this.isPicking.day
        this.model.time = this.isPicking.time
        this.model.duration = this.isPicking.duration
                
        this.$pubsub.$emit('picker.opened')
                
    },

    watch: {
    
        isPicking: {
        
            deep: true,

            handler: function(n) {

                if(n) {

                    this.model.space = n.space
                    this.model.day = n.day
                    this.model.time = n.time
                    this.model.duration = n.duration
                
                    this.$pubsub.$emit('picker.opened')

                }
            
            }
        
        }

    },

    methods: {

        onPlaced: function(e, day, space) {

			var model = { note: {} }
		
			model.day = parseInt(day)
			model.space = space
			model.time = e.time
			model.duration = e.duration

			Vue.set(this, 'model', model)

		},

        onCloseClick: function() {

            this.$pubsub.$emit('picker.closed')

            this.$emit('close')

            this.model.space = ''
            this.model.day = 0
            this.model.time = 0
            this.model.duration = 0

        },

        onConfirmClick: function() {
        
            this.$pubsub.$emit('picker.confirmed', this.model)

            this.$emit('confirmed', this.model)

            this.onCloseClick()

        },

		isCurrent: function(day, space) {

			if (this.model.day === parseInt(day) && this.model.space === space) {
			
				return {
					time: this.model.time,
					duration: this.model.duration
				}
			
			} else {

				return {
					time: 0,
					duration: 0
				}
			
			}
		
		},

		seatCount: function(item) {
		
			return (item.seats === 0) ? 'Unlimited' : item.seats.toString() + ' seat' + ((item.seats > 1) ? 's' : '')

		}
    
    }

}

</script>

<style scoped>

.preferences >>> .box-content {
    box-shadow: none;
}

.preferences >>> .item-value {
    display: flex;
}

.preferences-time {
	font-size: 14px;
    text-align: center;
	padding: 5px 6px;
	line-height: 18px;
	font-weight: 400;
	border-radius: 4px;
	background-color: #fff;
    border: 1px solid #eee;
    margin-right: 4px;
}

.spaces.is-picking {
    position: fixed;
    left: 320px;
    top: 80px;
    background-color: #fff;
    right: 0px;
    bottom: 0px;    
    overflow: auto;
    z-index: 100;
}

.is-mobile .spaces.is-picking,
.is-tablet .spaces.is-picking {
    left: 0px;
    top: 48px;
}

.spaces.is-picking .spaces-box {
    margin: 20px;
}

.spaces >>> .box-content {
    max-height: 600px;
    overflow: auto;
}

.spaces.is-picking >>> .box-content {
    max-height: 1000000px;
}

.spaces-table {
    border: 1px solid #eee;
}

.spaces-table:last-child {
	margin-bottom: 0px;
}

.spaces-table >>> .body {
    padding: 0px!important;
}

.spaces-table >>> .row {
    padding-right: 0px;
}

</style>